import { create } from 'zustand'

interface PhasedLoginState {
    step: number
    nextStepOnboardingPage: string
    laboratoryName: string
    setStep: (value: number) => void
    setNextStepOnboardingPage: (url: string) => void
    setLaboratoryName: (laboratoryName: string) => void
}

export const usePhasedLoginStore = create<PhasedLoginState>()(set => ({
    step: 0,
    setStep: step => set({ step }),
    nextStepOnboardingPage: '',
    setNextStepOnboardingPage: (url: string) => set({ nextStepOnboardingPage: url }),
    laboratoryName: '',
    setLaboratoryName: (laboratoryName: string) => set({ laboratoryName }),
}))
